import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import WhatsAppFloat from '../../components/feature/WhatsAppFloat';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import BlogNewsletter from './components/BlogNewsletter';
import BlogSeoBlock from './components/BlogSeoBlock';
import { updatePageSEO } from '../../utils/seoConfig';

const BlogPage = () => {
  useEffect(() => {
    updatePageSEO('blog');
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <BlogHero />
        <BlogGrid />
        <BlogNewsletter />
        <BlogSeoBlock />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default BlogPage;
